import { useCallback, useEffect, useMemo } from "react";
import { useSWRConfig } from "swr";

import { jsonApiAdapter } from "../../common/helpers/jsonapi/jsonapi";
import useApiRequestPost from "../../components/apiHooks/useApiRequestPost";
import { useCatalogueActions } from "../../contexts/CatalogueContext/CatalogueContext";
import { useConfigContext } from "../../contexts/ConfigContext/ConfigContext";
import { ICatalogue } from "./types";

const HOST: string = process.env.VITE_CLOUD_RUN_GATEWAY_HOST ?? "";
const END_POINT: string = process.env.VITE_API_CATALOG ?? "/v1/catalog";

const url: string = `${HOST}${END_POINT}`;

const POLL_INTERVAL_MS = 5 * 60 * 1000;

export const useRefreshCatalogue = () => {
	const { mutate } = useSWRConfig();

	return useCallback(() => mutate(url), [mutate]);
};

const useGetCatalogueData = () => {
	const { state: location } = useConfigContext((state) => state.location);
	const actions = useCatalogueActions();

	const payload = useMemo(
		() => ({
			url: location?.id ? url : "",
			triggerOnMount: true,
			body: {
				location: location?.id ?? "4a62e3bd-0597-417f-b031-ed3cd3b47ca7",
			},
			swrConfig: {
				revalidateOnFocus: false,
				refreshInterval: POLL_INTERVAL_MS,
			},
		}),
		[url, location?.id]
	);
	const { data: response, isLoading, error } = useApiRequestPost(payload);

	useEffect(() => {
		if (!response) return;

		const data = jsonApiAdapter(response) as ICatalogue[];

		// TODO: Add image preloading when PreloadContext is available
		// const productImgs = data.map((item) => item.product_image);
		// const productThumbnails = data.map((item) => item.product_thumbnail);
		// preloadImages([...productImgs, ...productThumbnails]);

		actions.SET_CATALOGUE_DATA(data);
		actions.SET_ISLOADING(false);
	}, [response, actions]);

	useEffect(() => {
		actions.SET_ISLOADING(isLoading);
		actions.SET_ERROR(error ? error.message : "");
	}, [isLoading, error, actions]);

	return { data: response, isLoading, error };
};

export default useGetCatalogueData;
